/**
 * Shared blog helpers (slug, constants, pagination).
 * Used by the public blog, CMS, and mirrored on the server.
 */

export const POSTS_COLLECTION = 'posts';
export const POST_SLUGS_COLLECTION = 'postSlugs';
export const ADMINS_COLLECTION = 'admins';
export const BLOG_PAGE_SIZE = 10;
export const POST_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

export const POST_FIELDS = [
  'title',
  'slug',
  'excerpt',
  'coverImageUrl',
  'body',
  'author',
  'tags',
  'status',
  'publishedAt',
  'updatedAt',
  'createdAt',
];

/**
 * Normalize a title or slug candidate into a URL-safe slug.
 *
 * @param {string} value
 * @returns {string}
 */
export const slugify = value => {
  if (!value || typeof value !== 'string') {
    return '';
  }
  return value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
    .slice(0, 120);
};

/**
 * Whether a slug is non-empty and URL-safe.
 *
 * @param {string} slug
 * @returns {boolean}
 */
export const isValidSlug = slug =>
  typeof slug === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug);

/**
 * Parse page number from a query string (defaults to 1).
 *
 * @param {string} search
 * @returns {number}
 */
export const pageFromSearch = search => {
  const params = new URLSearchParams(typeof search === 'string' ? search : '');
  const page = parseInt(params.get('page'), 10);
  return Number.isFinite(page) && page > 0 ? page : 1;
};

/**
 * Build a Sharetribe-style pagination object for PaginationLinks.
 *
 * @param {Object} opts
 * @param {number} opts.page
 * @param {number} opts.pageSize
 * @param {number} opts.totalItems
 * @returns {{ page: number, perPage: number, totalItems: number, totalPages: number }}
 */
export const buildPagination = ({ page, pageSize, totalItems }) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  return {
    page,
    perPage: pageSize,
    totalItems,
    totalPages,
  };
};
